export const FormStepWrapper: React.FC<{
  children: React.ReactNode;
  title: string;
  description: string;
  actions?: React.ReactNode;
}> = ({ children, title, description, actions }) => {
  return (
    <div
      className="max-w-4xl"
      data-loc="case-template-version-form-step-content"
    >
      <div className="rounded-lg border border-gray-200 bg-white">
        <CaseTemplateStepFormHeadline
          actions={actions}
          description={description}
          title={title}
        />

        <div className="space-y-3 p-5">{children}</div>
      </div>
    </div>
  );
};

const CaseTemplateStepFormHeadline: React.FC<{
  title: string;
  description: string;
  actions?: React.ReactNode;
}> = ({ title, description, actions }) => {
  return (
    <div className="flex flex-col gap-y-2 border-gray-200 border-b p-5">
      <div className="flex items-center justify-between">
        <h2
          className="font-inter-semibold-13px"
          data-loc="case-template-version-step-title"
        >
          {title}
        </h2>
        {actions}
      </div>
      <p
        className="font-inter-normal-12px text-gray-500"
        data-loc="case-template-version-step-description"
      >
        {description}
      </p>
    </div>
  );
};
